import { useState } from "react";
import Button from "../../UI/Buttons/Button";
import "./Variant.scss"
import ReactHtmlParser from 'html-react-parser';
import InputWrapperRefacture from "../../UI/Inputs/InputWrapperRefacture";
import { useTranslation } from 'react-i18next';
const Variant = (props) => {
    const { varQuantity, incrementQuantity, decreaseQuantity, variant, highlighted, oneproductbuy, isMultiVariant, isMultiVariantDropdown, setQuantityForVariant, selected, selectVariant } = props;
    const { t } = useTranslation();


    const blockStyle = () => {
        return (
            <div className={`card ${highlighted ? "highlighted-card" : ''}`}>
                {props?.badge && (
                    <div className="badge">
                        {props.badge}
                    </div>
                )}
                <div className="card-header">
                    <h3>{props.title || props?.description || "Variant Title"}</h3>
                </div>
                <div className="card-image">
                    <img src={props?.image || "https://placehold.co/600x400"} alt={props.title || "Product"} />
                </div>
                <div className="card-pricing">
                    <div className="original-price">{props.originalPrice || "£50"}</div>
                    <div className="current-price">
                        <span className="price-amount">£{props?.price || "20"}</span>
                        <span className="price-frequency">{props.priceFrequency || "One-off"}</span>
                    </div>
                    <div className="offer-end-text">{props.offerEndText || "Offer ends in 10 days"}</div>
                </div>
                <div className="card-description">
                    <p className="subscription-text">{props.shortDescription || "Great value subscription for all types of user"}</p>
                </div>
                {(isMultiVariant || isMultiVariantDropdown) && (
                    <div className="card-quantity">
                        {isMultiVariant ? (
                            <div className="row-items">
                                <button className="ghost-button small" onClick={() => decreaseQuantity(variant)}> - </button>
                                <InputWrapperRefacture
                                    inputSize="xsmall"
                                    inputFieldType="simplefield"
                                    id={`variant-id-${variant}`}
                                    name={`variant-name-${variant}`}
                                    value={varQuantity}
                                    readOnly
                                />
                                <button className="ghost-button small" onClick={() => incrementQuantity(variant)}> + </button>
                            </div>
                        ) : (
                            <div className="qty-selector">
                                <span className="qty-label">Qty</span>
                                <select
                                    className="qty-dropdown"
                                    value={varQuantity}
                                    onChange={(e) => setQuantityForVariant(variant, parseInt(e.target.value))}
                                >
                                    {[...Array(11).keys()].map((num) => (
                                        <option key={num} value={num}>{num}</option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>
                )}
                <div className="card-action">
                    <button className="subscribe-btn" onClick={() => oneproductbuy(variant)}>Subscribe</button>
                </div>
                <div className="card-features">
                    <h3>What's included</h3>
                    <ul>
                        {(props?.features || [
                            "Unrestricted access to abacusemedia.com",
                            "Unlimited access to the E-paper and Abacus mobile app",
                            "Access to the Abacus archive",
                            "50% discount off Social and Personal announcements"
                        ]).map((feature, i) => (
                            <li key={i}>{feature}</li>
                        ))}
                    </ul>
                </div>
            </div>
        )
    }

    const listStyle = () => {
       
        return  (
            <div className={`card list-block ${highlighted ? "highlighted-card" : ''}`}>
                {props?.badge && (
                    <div className="badge">
                        {props.badge}
                    </div>
                )}
                <div className="list-image">
                    <img src={props?.image || "https://placehold.co/264x148"} alt={props.title || "Product"} />
                </div>
                <div className="list-content">
                    <h3>{props.title || props?.description || `Variant Title ${variant}`}</h3>
                    <div className="card-pricing">
                        <div className="original-price">{props.originalPrice || "£40"}</div>
                        <div className="current-price">
                            <span className="price-amount">£{props?.price || "20"}</span>
                            <span className="price-frequency">{props.priceFrequency || "One-off"}</span>
                        </div>
                        <div className="offer-end-text">{props.offerEndText || "Offer ends in 10 days"}</div>
                    </div>
                    <p className="subscription-text">{props.subscriptionText || "Your subscription will start today and renew automatically on the same day each month"}</p>
                    <div className="card-features">
                        <h3>What's included</h3>
                        <ul>
                            {(props?.features || [
                                "Unrestricted access to abacusemedia.com",
                                "Unlimited access to the E-paper and Abacus mobile app",
                                "Access to the Abacus archive",
                                "50% discount off Social and Personal announcements"
                            ]).map((feature, i) => (
                                <li key={i}>{feature}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="card-action">
                        {isMultiVariant ? (
                            <div className="row-items">
                                <button className="ghost-button small" onClick={() => decreaseQuantity(variant)}> - </button>
                                <span className="qty-value">{varQuantity}</span>
                                <button className="ghost-button small" onClick={() => incrementQuantity(variant)}> + </button>
                            </div>
                        ) : (
                            <button className="subscribe-btn" onClick={() => oneproductbuy(variant)}>Subscribe</button>
                        )}
                    </div>
                </div>
            </div>
        )
    }
    const pillStyle = () => {
        return (
            <div className={`card pill-card ${selected ? "pill-selected" : ''}`} onClick={() => selectVariant(variant)}>
                {props?.badge && (
                    <div className="badge">
                        {props.badge}
                    </div>
                )}
                <div className="pill-header">
                    <span className={`pill-radio ${selected ? 'pill-radio-selected' : ''}`}>
                        {selected && <span className="pill-radio-dot"></span>}
                    </span>
                    <h3>{props.title || props?.description || "Variant Title"}</h3>
                </div>
                <div className="card-pricing">
                    <div className="original-price">{props.originalPrice || "£40"}</div>
                    <div className="current-price">
                        <span className="price-amount">£{props?.price || "20"}</span>
                        <span className="price-frequency">{props.priceFrequency || "Per year"}</span>
                    </div>
                    <div className="offer-end-text">{props.offerEndText || "Offer ends in 10 days"}</div>
                </div>
                <div className="card-description">
                    <p className="subscription-text">{props.shortDescription || "Great value subscription for all types of user"}</p>
                </div>
                <div className="card-features">
                    <h3>What's included</h3>
                    <ul>
                        {(props?.features || [
                            "Unrestricted access to abacusemedia.com",
                            "Unlimited access to the E-paper and Abacus mobile app",
                            "Access to the Abacus archive",
                            "50% discount off Social and Personal announcements"
                        ]).map((feature, i) => (
                            <li key={i}>{feature}</li>
                        ))}
                    </ul>
                </div>
                {isMultiVariantDropdown && (
                    <div className="card-action" onClick={(e) => e.stopPropagation()}>
                        <div className="qty-selector">
                            <span className="qty-label">Qty</span>
                            <select
                                className="qty-dropdown"
                                value={varQuantity}
                                onChange={(e) => setQuantityForVariant(variant, parseInt(e.target.value))}
                            >
                                {[...Array(11).keys()].map((num) => (
                                    <option key={num} value={num}>{num}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    return (  
        <>
            {
               props?.setStyle === "pill" ? pillStyle() :
               props?.setStyle === "list" ? listStyle() :
                    blockStyle() 
        }
        </>
    )

}

export default Variant;